import { render } from "./BaseLayout.vue?vue&type=template&id=59d2eb94"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=59d2eb94&lang=css"

import exportComponent from "../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@17.4.2_vue@3.5.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__